
import { AlertTriangle } from "lucide-react";

const PainPoints = () => {
  const painPoints = [
    "You're not sure if your tags are firing properly — and you're wasting time in debug hell.",
    "Your reports don't match reality, and your team is losing trust in the data.",
    "You've tried fixing it yourself or hiring a dev, but things keep breaking or going untracked."
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center animate-on-scroll">
          <div className="flex items-center justify-center gap-2 mb-6">
            <AlertTriangle className="h-8 w-8 text-destructive" />
            <h2 className="text-destructive">Struggling to Make Sense of Your Analytics?</h2>
          </div>
          
          <div className="space-y-6 mb-12">
            {painPoints.map((pain, index) => (
              <div 
                key={index}
                className="bg-red-50 border border-red-200 rounded-lg p-6 text-left animate-on-scroll"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <p className="text-text-primary text-lg leading-relaxed">{pain}</p>
              </div>
            ))}
          </div>

          <div className="bg-accent/50 border border-primary/20 rounded-xl p-6 sm:p-8 animate-on-scroll">
            <h3 className="text-2xl font-semibold text-text-primary mb-4">Here's the Truth:</h3>
            <p className="text-lg text-text-secondary leading-relaxed">
              You don't need to become a tracking expert or hire a full-time analyst to fix this. 
              Most issues stem from poor tag structure, missing DataLayer strategy, or platform misconfigurations. 
              You deserve clarity without chaos.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainPoints;
